// import { useParams } from 'next/navigation';
import { SVGProps } from 'react';

const CartVector = (props: SVGProps<SVGSVGElement>) => {
  // const { section } = useParams<{ section?: string }>();
  // const sectionValue = section?.toLowerCase();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800"
      height="800"
      viewBox="0 0 24 24"
      fill="none"
      // stroke={sectionValue === 'woman' || !sectionValue ? '#fff' : '#000'}
      {...props}
    >
      <path d="M17.2498 20.9998H1.5L2.12499 6.25C6.74994 6.49999 15.5363 6.50159 16.3748 6.5C16.4998 6.49976 17.2082 16.4582 17.2498 20.9998Z" />
      <path d="M13.6256 6.49994C13.7506 4.66663 13.3756 1 10.8757 1C7.75069 1 7.87569 4.87496 7.87569 6.37494" />
      <path d="M10.8756 6.49994C11.0006 4.66663 10.6256 1 8.12564 1C5.00068 1 5.12568 4.87496 5.12568 6.37494V9.37491L4.25 10.1249V12.7499H6.37498V10.1249L5.24999 9.49991" />
    </svg>
  );
};

export default CartVector;
